import { useState } from "react";
import { Menu, X, Instagram } from "lucide-react";

const LINKS = [
  { label: "Scam Alerts", href: "#scam-alerts", testId: "nav-link-scam-alerts" },
  { label: "What We Do", href: "#services", testId: "nav-link-services" },
  { label: "Community", href: "#community", testId: "nav-link-community" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background border-b border-border" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img
            src="/logo-mark-navy.png"
            alt="CyberSecYYC"
            className="h-8 md:h-9 w-auto"
            data-testid="nav-logo-image"
          />
          <span className="font-display font-semibold text-xl md:text-2xl tracking-tight text-foreground">
            CyberSec<span className="text-primary">YYC</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://www.instagram.com/cybersecyyc/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="CyberSecYYC on Instagram"
            data-testid="nav-instagram-link"
            className="p-2.5 rounded-full border border-border hover:bg-secondary transition-colors duration-200"
          >
            <Instagram className="w-5 h-5" strokeWidth={1.8} />
          </a>
          <a
            href="#contact"
            data-testid="nav-book-chat-button"
            className="bg-primary text-primary-foreground font-display font-medium text-sm px-6 py-3 rounded-full hover:scale-[1.03] transition-transform duration-200"
          >
            Book a Coffee Chat
          </a>
        </div>

        <button
          className="md:hidden p-2 rounded-full border border-border"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="nav-mobile-menu-button"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background border-t border-border px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`${l.testId}-mobile`}
              className="font-display font-medium text-lg"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="nav-book-chat-button-mobile"
            className="bg-primary text-primary-foreground font-display font-medium text-center px-6 py-3.5 rounded-full"
          >
            Book a Coffee Chat
          </a>
        </div>
      )}
    </header>
  );
}
